import { ROLES as R } from "../core/roles";
import { lud, rule } from "../core/rule";

export const deliveryDocumentationPermissions = {
  view: "deliveryDocumentation.view",
  admin: { view: "deliveryDocumentation.admin.view" },
};

export const deliveryDocumentationGrants = {
  // Branch users document orders and store invoices for their assigned branches only: the backend
  // (lud-backend/utils/access/deliveryDocumentationAccess.js) resolves the assignment and scopes every
  // read and change. A branch user needs at least one valid assigned branch (NA-035).
  "deliveryDocumentation.view": rule(lud(R.BRANCH), { requiresBranch: true }),
  // Administration (hierarchy, exports, disputes, audit log) stays with the ceo-level tier.
  "deliveryDocumentation.admin.view": rule(lud()),
};
